import type { Components, Theme } from "@mui/material";

import { primitiveColors } from "@dfp/isomorphic-design-tokens";

export const breadcrumbsTheme: Components<Theme>["MuiBreadcrumbs"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "& li:first-of-type a": {
        color: primitiveColors.greyscale[300],
        padding: theme.spacing(0.5),
      },
      "& li:last-of-type a": {
        color: primitiveColors.darkGreen[900],
        padding: theme.spacing(0.5, 1),
        borderRadius: theme.spacing(0.75),
        backgroundColor: primitiveColors.greyscale[50],
        fontWeight: 600,
      },
      "& a": {
        color: primitiveColors.greyscale[600],
        fontWeight: 600,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.body2.fontSize,
        "&:hover": {
          textDecoration: "underline",
        },
      },
      "& svg": {
        height: "20px",
        width: "20px",
      },
    }),
    separator: () => ({
      color: primitiveColors.greyscale[100],
    }),
  },
};
